/* angular:styles/component:css;f0f5e2d0e20e2120b88a29bb91afbb3639ac0a347677b28fe670e268957b47b0;/opt/build/repo/ui/src/app/shared/components/pull-to-refresh/pull-to-refresh.ts */
.ion-col-with-left-and-right-icon {
  display: flex;
  justify-content: center;
}
.ion-col-with-left-and-right-icon ion-text {
  padding-left: 1%;
  padding-right: 1%;
  align-self: center;
}
/*# sourceMappingURL=pull-to-refresh.css.map */
